import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";

const getHeaderConfig = () => {
    const userStorage = JSON.parse(localStorage.getItem('user'));
    const token = userStorage?.token || "";
    
    return {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    };
};

const save = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "tds/tds-insert", data, getHeaderConfig());
        return response.data;
};

const list = async () => {
    const response = await axios
        .get(BASE_API_URL + "tds/list", getHeaderConfig());
        return response;
};

const activeList = async () => {
    const response = await axios
        .get(BASE_API_URL + "tds/active-tds-list", getHeaderConfig());
        return response;
};

const tdsById = async (tdsId) => {
    const response = await axios
        .get(`${BASE_API_URL}tds/get-tds-by-id/${tdsId}`, getHeaderConfig());
        return response;
}

const tdsSectionService = {
    save,
    list,
    tdsById,
    activeList
};

export default tdsSectionService;